import type {
  ActiveSourcingChannelDetails,
  SourcingCampaignIndex,
  SourcingPurchaseDetails,
} from 'api-clients/monolith';

import type {
  SourceCampaignContext,
  SourceChannelContext,
} from '@/types/wx-copilot-context';

export function sourceChannelContext(
  campaign: ActiveSourcingChannelDetails,
): SourceChannelContext {
  return {
    id: campaign.sourcing_channel.external_id,
    name: campaign.sourcing_channel.name,
    slug: campaign.sourcing_channel.slug,
    campaignId: campaign.sourcing_purchase_id,
    status: campaign.status,
    budget: campaign.budget_stats.expected,
    spend: campaign.budget_stats.actual,
    startDate: campaign.starts_at,
    endDate: campaign.end_at,
  };
}

export function sourceCampaignContext(
  campaign: SourcingPurchaseDetails,
  openingId?: string,
): SourceCampaignContext {
  return {
    id: campaign.sourcing_purchase_id,
    name: campaign.campaign_title,
    openingId,
    channelId: campaign.sourcing_channel.external_id,
    channelName: campaign.sourcing_channel.name,
    channelSlug: campaign.sourcing_channel.slug,
    status: campaign.status,
    budget: campaign.budget,
    budgetType: campaign.budget_type,
    spend: campaign.budget_spent,
    startDate: campaign.starts_at,
    endDate: campaign.end_at,
    timeZone: campaign.time_zone,
  };
}

export function sourceCampaignRowContext(
  campaign: SourcingCampaignIndex,
): SourceCampaignContext {
  return {
    id: campaign.id,
    openingId: campaign.opening_external_id,
    channelId: campaign.sourcing_channel.external_id,
    channelName: campaign.sourcing_channel.name,
    channelSlug: campaign.sourcing_channel.slug,
    status: campaign.status,
    budget: campaign.budget,
    budgetType: campaign.budget_type,
    spend: campaign.spend,
    startDate: campaign.start_date,
    endDate: campaign.end_date,
    timeZone: campaign.time_zone,
  };
}

export function sourceCampaignChannelContext(
  campaign: SourceCampaignContext,
): SourceChannelContext {
  return {
    id: campaign.channelId,
    name: campaign.channelName,
    slug: campaign.channelSlug,
    campaignId: campaign.id,
    status: campaign.status,
    budget: campaign.budget,
    budgetType: campaign.budgetType,
    spend: campaign.spend,
    startDate: campaign.startDate,
    endDate: campaign.endDate,
    timeZone: campaign.timeZone,
  };
}
